/**
 * Yeni ankette hazır gelen giriş ve kapanış metinleri (kağıt değerlendirme
 * formundaki gibi). Anket bazında düzenlenebilir; boş bırakılırsa gösterilmez.
 */
export const DEFAULT_SURVEY_INTRO_TEXT =
  "Değerli Katılımcı;\n\nAlmış olduğunuz eğitimle ilgili olarak belirteceğiniz görüşleriniz, genel bir değerlendirme yapmak ve düzeltici önlemler alarak daha kaliteli bir hizmet sunmak için bize yol gösterecektir. Bu nedenle bu formu titizlikle ve önemseyerek doldurmanızı diler, ilginize teşekkür ederiz.";

export const DEFAULT_SURVEY_CLOSING_TEXT = "Anketimize katıldığınız için teşekkür ederiz.";
